import type { DeepRequired } from '../fixtures.types'

const caseVersion: DeepRequired<CaseVersion> = {
  __typename: 'CaseVersion',
  id: 'TEST_ID',
  version: 1,
  created_at: '',
  version_created_at: null,
  clients: [],
  versions: [],
  details: {
    __typename: 'Case',
    id: 'TEST_ID',
    owner_user_id: null,
    createLeadCaseReferral: null,
    change_of_preference_reason: [],
    preference_mortgage_reason: null,
    status: null,
    regulated_by: null,
    has_previously_owned_property: false,
    has_seen_face_to_face: null,
    impersonation_check_performed: null,
    impersonation_check_details: null,
    is_debt_consolidation: false,
    btl_has_lived: null,
    btl_will_lived: null,
    btl_is_operating_a_business: null,
    btl_through_company: null,
    client_ids: [],
    is_introduced: null,
    introducer_details: null,
    shared_budget: null,
    owner: null,
    mortgages: [],
    mortgages_cp: [],
    clients: [],
    documents: [],
    new_property: null,
    flags: null,
    protection: null,
    preference_related_property_sale: null,
    preference_details: null,
    preference_target_property: null,
    preference_target_deposit: null,
    preference_target_property_value: null,
    preference_loan_amount: null,
    preference_term: null,
    preference_cashback: null,
    preference_overpayment: null,
    preference_fixed_rate: null,
    preference_free_valuations: null,
    preference_tracker: null,
    clientsUser: [],
    additional_loan_required: null,
    additional_loans: [],
    additional_metadata: null,
    agreed_monthly_protection_budget: null,
    calculated_values: null,
    cancellation_reason: null,
    conveyancing_status: null,
    conveyancing_type: null,
    conveyancing_updates: [],
    debt_consolidation_alternative_options: null,
    debt_consolidation_reason_for_consolidated_debts: null,
    details: null,
    document_categories: [],
    document_totals: [],
    fee_option_title: null,
    fees: [],
    introducer_id: null,
    last_significant_update: null,
    last_update: null,
    lead_metadata: null,
    lender_has_proposed_new_product: null,
    new_property_cp: null,
    override_client_eidv_results: null,
    own_solicitor_details: null,
    owner_organisation_id: null,
    owner_organisation: null,
    pay_rise_expected_details: null,
    predicted_revenue: null,
    preference_completion_speed_important: null,
    preference_early_year_discount: null,
    preference_fee_to_loan: null,
    preference_free_conveyancing: null,
    preference_initial_period_months: null,
    preference_interest_only_repayment_strategy: null,
    preference_link_finances: null,
    preference_mortgage_class: null,
    preference_mortgage_loan_amount: null,
    preference_no_early_repayment_charge: null,
    preference_no_tie_in: null,
    preference_payment_holiday: null,
    preference_repayment_percentage: null,
    preference_upper_limit: null,
    preference_vary_repayment_amount: null,
    property_portfolio: null,
    protection_products: [],
    reason_for_further_advance: null,
    preference_reason_for_debt_consolidation: null,
    recommendation_reason_additional_borrowing: null,
    recommendation_reason_entitlement_to_state_benefits: null,
    recommendation_reason_for_affordability: null,
    recommendation_reason_for_equity_disparity: null,
    recommendation_reason_for_further_advance: null,
    recommendation_reason_for_recommendation: null,
    recommendation_reason_for_recommendation_term_increase: null,
    recommendation_reason_for_remortgage_cost_increase: null,
    recommendation_reason_help_to_buy_loan_repayment_strategy: null,
    reason_for_recommendation_product_type: null,
    reason_for_recommendation_initial_term: null,
    recommendation_reason_retirement_interest_only: null,
    recommendation_reason_strategy_for_btl_void_period_coverage: null,
    recommendation_reason_term_into_retirement: null,
    recommendation_strategy_for_payment_erc: null,
    recommendation_term_reason: null,
    referrals: [],
    related_users: [],
    related_cases: [],
    remortgage_property: null,
    remortgage_property_cp: null,
    shared_equity_repayment_details: null,
    suitability_report_recommendation_introduction: null,
    third_party_orgs: [],
    transition_client_versions: [],
    transition_mortgage_versions: [],
    transition_property_versions: [],
    transition_protection_versions: [],
    verifications: {
      __typename: 'CaseVerification',
      verification_collections: [],
      tested_case_ids: [],
      tested_client_ids: [],
      tested_mortgage_ids: [],
      tested_property_ids: [],
      will_need_review: false,
    },
    external: [],
    survey_answers: [],
    miDocuments: null,
    dip_result: [],
    addendum_reasons: {
      __typename: 'AddendumReasons',
      additional_details: null,
      cover_change_self_identified: null,
      cover_change_system_identified: null,
    },
    document_requirements: [],
  },
}

export default caseVersion
